import fetch from 'auth/FetchInterceptor';
import { AUTH_SERVICE_LOGIN, AUTH_SERVICE_FORGOT_PASSWORD, AUTH_SERVICE_SET_PASSWORD } from 'constants/ApiConstant';

const AuthService = {
  login(data) {
    return fetch({
      url: `${AUTH_SERVICE_LOGIN}/admin-login`,
      method: 'post',
      data,
    });
  },

  logout() {
    return fetch({
      url: `${AUTH_SERVICE_LOGIN}/logout`,
      method: 'post',
    });
  },

  forgotPassword(data) {
    return fetch({
      url: `${AUTH_SERVICE_FORGOT_PASSWORD}`,
      method: 'post',
      data,
    });
  },

  resetPassword(data) {
    const { password, token } = data;
    return fetch({
      url: `${AUTH_SERVICE_SET_PASSWORD}/?token=${token}`,
      method: 'post',
      data: { password },
    });
  },
};

export default AuthService;
